// ItemSourceSentenceTranslationValidator item workflow statuses
export enum ItemSourceSentenceTranslationValidatorItemStatus {
  PENDING = 0,
  NEEDS_USER_REVIEW = 1,
  DONE = 2,
}

// ItemSourceSentenceTranslationValidator parent statuses
export enum ItemSourceSentenceTranslationValidatorStatus {
  PENDING = 0,
  NEEDS_USER_REVIEW = 1,
  DONE = 2,
}

// Shared async task status (same as backend AsyncTasksQueue)
export enum AsyncTaskStatus {
  PENDING = 0,
  DOING = 1,
  DONE = 2,
  FAILED = 3,
  DEAD_LETTER = 4,
  CANCELLED = 5,
  AWAITING_MEMORY = 6,
}

export const ItemSourceSentenceTranslationValidatorStatusLabels: Record<ItemSourceSentenceTranslationValidatorStatus, string> = {
  [ItemSourceSentenceTranslationValidatorStatus.PENDING]: 'pending',
  [ItemSourceSentenceTranslationValidatorStatus.NEEDS_USER_REVIEW]: 'needs_user_review',
  [ItemSourceSentenceTranslationValidatorStatus.DONE]: 'done',
};

export const ItemSourceSentenceTranslationValidatorItemStatusLabels: Record<ItemSourceSentenceTranslationValidatorItemStatus, string> = {
  [ItemSourceSentenceTranslationValidatorItemStatus.PENDING]: 'pending',
  [ItemSourceSentenceTranslationValidatorItemStatus.NEEDS_USER_REVIEW]: 'needs_user_review',
  [ItemSourceSentenceTranslationValidatorItemStatus.DONE]: 'done',
};
